import {
  checkboxGroupSchema,
  checkboxGroupUI,
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

const previousMarriageOptions = {
  claimant: 'I had a previous marriage',
  veteran: 'The Veteran had a previous marriage',
};

/** @type {PageSchema} */
export default {
  depends: formData => formData.claimantRelationship === 'SURVIVING_SPOUSE',
  uiSchema: {
    ...titleUI(content['household-spouse-marriages-title']),
    recognizedAsSpouse: yesNoUI({
      title: content['household-spouse-marriages-recognized'],
    }),
    'view:hasAnyPreviousMarriages': yesNoUI({
      title: content['household-spouse-marriages-previous-yes-no'],
    }),
    hadPreviousMarriages: checkboxGroupUI({
      title: content['household-spouse-marriages-had-previous'],
      required: formData => formData?.['view:hasAnyPreviousMarriages'] === true,
      labels: previousMarriageOptions,
      errorMessages: {
        required: content['household-spouse-marriages-had-previous-error'],
      },
      expandUnder: 'view:hasAnyPreviousMarriages',
      expandUnderCondition: true,
    }),
  },
  schema: {
    type: 'object',
    required: ['recognizedAsSpouse', 'view:hasAnyPreviousMarriages'],
    properties: {
      recognizedAsSpouse: yesNoSchema,
      'view:hasAnyPreviousMarriages': yesNoSchema,
      hadPreviousMarriages: checkboxGroupSchema(
        Object.keys(previousMarriageOptions),
      ),
    },
  },
};
